module.exports = __webpack_public_path__ + "static/media/nodejs.be2df796.svg";